export const shadows = {
    sm: '0px 2px 12px rgba(37, 62, 177, 0.08)',
    md: '0px 8px 24px 0px rgba(37, 62, 177, 0.12)'
}
